export const SERVER_ERROR_TYPES = {
  missingRequiredParameter: "missing-required-parameter",
  missingPermissions: "missing-required-permissions",
};
